import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListBrandsRequest, ListBrandsResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const brandApi = createApi({
    reducerPath: "brandApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listBrands: builder.query<ListBrandsResponse, ListBrandsRequest>({
            query: body => ({
                url: "brand/list",
                method: "POST",
                body
            })
        })
    })
});

export const { useListBrandsQuery } = brandApi;
